<template>
  <div class="question-panel">
    <template v-if="question">
      <header class="test-heading"><div><span class="test-eyebrow">PRATİK TESTİ</span><h2>Bilgini kontrol et</h2></div><span class="test-count">Soru {{ progressNumber }} / {{ ExcerciseData.length }}</span></header>
      <div class="test-progress" role="progressbar" aria-label="Test ilerlemesi" :aria-valuenow="progressNumber" :aria-valuemax="ExcerciseData.length" aria-valuemin="0"><div :style="{ width: progressWith + '%' }"></div></div>
      <p class="test-hint">Bir cevap seçtiğinde sonraki soruya geçilir.</p>
      <div :key="questionNumber" class="question-card">
        <div class="question-text" v-html="question.title"></div>
        <div class="test-options" role="group" :aria-label="'Soru ' + progressNumber + ' cevapları'">
          <button v-for="(option, index) in [question.optionA, question.optionB, question.optionC, question.optionD]" :key="index" type="button" class="test-option" @click="NextQuestion(index)"><span class="option-letter">{{ ['A', 'B', 'C', 'D'][index] }}</span><div class="option-body" v-html="option"></div></button>
        </div>
      </div>
    </template>
    <div v-else class="question-status" role="status"><i class="bi bi-journal-check" aria-hidden="true"></i><p>{{ ExcerciseData && ExcerciseData.length ? 'Cevapların işleniyor…' : 'Bu testte henüz soru bulunmuyor.' }}</p></div>
  </div>
</template>
<script>
  import {DateFormat} from '@/common/datetime-helper';
  export default {
    name: "ExcerciseTest",
    props: {
      //[{id:'',sequence:1,question:'',audioiFileName:'',imageFileName:'',answers:['are','am','is','be'],right:0}]
      Visible:{
        type:Boolean,
        default:false
      },
      ExcerciseData:{
        type:Object,
      },
    },
    data() {
      return {
        questionNumber:0,
        userAnswers:[],
        beginTime:DateFormat(new Date().toUTCString(), 'yyyy-mm-dd hh:MM:ss', true),
        finishTime:''
      };
    },
    computed: {
      progressNumber() {
        if(this.ExcerciseData && this.ExcerciseData.length>0){
          let questionCount = this.ExcerciseData.length;
          if (this.questionNumber <= 0) {
              return 1;
          }
          else if ((questionCount - 1) <= this.questionNumber) {
              return questionCount;
          }
          else {
              return (this.questionNumber + 1);
          }
        }
        return 1;
      },
      progressWith: function () {
        if(this.ExcerciseData && this.ExcerciseData.length>0){
          return ((this.progressNumber * 100) / this.ExcerciseData.length).toFixed(1);
        }
        return 0;
      },
      question(){
        let result = null
        if(this.ExcerciseData && this.ExcerciseData.length>0){
          if(this.questionNumber>=0 && this.questionNumber<this.ExcerciseData.length){
            let data = this.ExcerciseData[this.questionNumber];
            result = {
              title : data.question,
              optionA : data.answers[0],
              optionB : data.answers[1],
              optionC : data.answers[2],
              optionD : data.answers[3]
            };
          }
        }
        return result;
      },
    },
    methods: {
      NextQuestion(value=0){
        if (this.questionNumber >= 0 && this.questionNumber < this.ExcerciseData.length) {
          let data = this.ExcerciseData[this.questionNumber];
          this.userAnswers.push({ Id: data.id, Answer: value });
        }
        this.questionNumber++;
        if (this.questionNumber >= this.ExcerciseData.length) {
          this.finishTime=DateFormat(new Date().toUTCString(), 'yyyy-mm-dd hh:MM:ss', true);
          this.$emit('SaveAnswer',{
            testId:null,
            beginDate:this.beginTime,
            finishDate:this.finishTime,
            answerContent:JSON.stringify(this.userAnswers)
          });
        }
      },
      init(){
        this.questionNumber=0;
        this.beginTime=DateFormat(new Date().toUTCString(), 'yyyy-mm-dd hh:MM:ss', true);
        this.finishTime='';
        this.userAnswers=[];
      }
    },
    watch: {
      Visible:function(){
        this.init();
      },
      ExcerciseData:function(){
        this.init();
      }
    }
  };
  </script>
  
  <style scoped>
.question-panel { color: #334155; }
.test-heading { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; margin-bottom: 20px; }
.test-eyebrow { font-size: 11px; font-weight: 600; letter-spacing: .1em; color: #738174; }
h2 { font-size: 22px; color: #20382d; margin: 6px 0 0; }
.test-count { display: inline-block; background: #f1f5f9; color: #526174; padding: 7px 12px; border-radius: 9px; font-size: 13px; font-weight: 600; }
.test-progress { height: 6px; background: #edf2f6; border-radius: 6px; overflow: hidden; }
.test-progress > div { height: 100%; background: var(--brand-primary); }
.test-hint { margin: 14px 0 24px; color: #64748b; font-size: 14px; line-height: 1.6; }
.question-card { border: 1px solid #e2e8f0; border-radius: 14px; padding: 24px; background: #fff; }
.question-text { margin: 18px 0 24px; font-size: 19px; line-height: 1.75; overflow-wrap: anywhere; color: #20382d; }
.question-text :deep(p:last-child), .option-body :deep(p:last-child) { margin-bottom: 0; }
.question-text :deep(img), .option-body :deep(img) { max-width: 100%; height: auto; }
.test-options { display: grid; gap: 12px; }
.test-option { display: flex; align-items: flex-start; gap: 14px; width: 100%; padding: 16px; text-align: left; border: 1px solid #e2e8f0; border-radius: 12px; background: #fff; color: #334155; font-size: 16px; line-height: 1.6; }
button.test-option:hover { background: #f0fdf7; border-color: #86cdb1; }
button.test-option:focus-visible { outline: 3px solid var(--brand-primary-hover); outline-offset: 3px; }
.option-letter { display: flex; align-items: center; justify-content: center; flex: 0 0 30px; height: 30px; background: #f1f5f9; border-radius: 8px; font-size: 14px; font-weight: 700; }
.option-body { min-width: 0; overflow-wrap: anywhere; }
.question-status { padding:40px 16px; text-align:center; color:#637269; }
.question-status i { font-size:2rem; color:var(--brand-link); }
.question-status p { margin:16px 0 0; }
@media(max-width: 575px) { .question-card { padding: 16px; } .question-text { font-size: 17px; } .test-option { padding: 12px; } }
</style>
